import { createModule } from 'vuex-class-component';
import { routeDefinition, IRoute } from '@/router/route-definition';

const VuexModule = createModule({
    namespaced: 'route',
    strict: true,
});

export class RouterStore extends VuexModule {
    private routes: IRoute[] = routeDefinition;

    get allRoutes() {
        return this.routes;
    }

    get displayRoutes() {
        return this.routes.filter((x) => x.display);
    }
}
